

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Autoplay, Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';

// Import images
import pptimg01 from '../assets/pptoct2024/img01.jpg';
import pptimg02 from '../assets/pptoct2024/img02.jpg';
import pptimg03 from '../assets/pptoct2024/img03.jpg';
import pptimg04 from '../assets/pptoct2024/img04.jpg';
import pptimg05 from '../assets/pptoct2024/img05.jpg';
import pptimg06 from '../assets/pptoct2024/img06.jpg';
import pptimg07 from '../assets/pptoct2024/img07.jpg';
import pptimg08 from '../assets/pptoct2024/img08.jpg';
import pptimg09 from '../assets/pptoct2024/img09.jpg';
import pptimg10 from '../assets/pptoct2024/img10.jpg';
import pptimg11 from '../assets/pptoct2024/img11.jpg';
import pptimg12 from '../assets/pptoct2024/img12.jpg';
import pptimg13 from '../assets/pptoct2024/img13.jpg';
import pptimg14 from '../assets/pptoct2024/img14.jpg';
import pptimg15 from '../assets/pptoct2024/img15.jpg';
import pptimg16 from '../assets/pptoct2024/img16.jpg';
import pptimg17 from '../assets/pptoct2024/img17.jpg';
import pptimg18 from '../assets/pptoct2024/img18.jpg';

// Image data
const data = [
  { image: pptimg01 },
  { image: pptimg02 },
  { image: pptimg03 },
  { image: pptimg04 },
  { image: pptimg05 },
  { image: pptimg06 },
  { image: pptimg07 },
  { image: pptimg08 },
  { image: pptimg09 },
  { image: pptimg10 },
  { image: pptimg11 },
  { image: pptimg12 },
  { image: pptimg13 },
  { image: pptimg14 },
  { image: pptimg15 },
  { image: pptimg16 },
  { image: pptimg17 },
  { image: pptimg18 },
];

const PptCarousel = () => {
  return (
    <div className="bg-gradient-to-b from-gray-100 to-purple-100 py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-extrabold text-3xl md:text-4xl text-purple-800 mb-4">
            Our Company Work Profile PPT
          </h1>
          <p className="font-semibold text-lg md:text-xl text-blue-800 mb-8">
            We provide high-standard clean presentations for your business solutions.
          </p>
        </div>

        <Swiper
          breakpoints={{
            340: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          freeMode={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[FreeMode, Pagination, Autoplay, Navigation]}
          className="mySwiper"
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl">
                <div className="relative w-full h-64 md:h-80">
                  <img
                    src={item.image}
                    alt={`PPT Slide ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-4 bg-white">
                  <p className="text-center text-purple-800 font-semibold">
                    Slide {index + 1}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default PptCarousel;


